import * as types from "../types/wallet"

const initialState = null

const walletReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_WALLET_DETAILS:
      return { ...action.wallet }
    case types.CLEAR_WALLET_DETAILS:
      return null
    default:
      return state
  }
}

export default walletReducer